import { Guid } from '../../../Guid';
import { DeviceTaskType } from '../IDevice';
import { DeviceControlFeature, IDeviceTask } from '../IDeviceTask';

export class DeviceTask implements IDeviceTask {
    private _taskType: DeviceTaskType = DeviceTaskType.GetChannelsState;
    private _featureType: DeviceControlFeature = DeviceControlFeature.GetState;
    private _channel: number = 0;
    private _guid: string = Guid.NewGuid();
    private _deviceGuid: string = "";

    get TaskType(): DeviceTaskType {
        return this._taskType;
    }

    set TaskType(taskType: DeviceTaskType) {
        this._taskType = taskType;
    }

    get FeatureType(): DeviceControlFeature {
        return this._featureType;
    }

    set FeatureType(featureType: DeviceControlFeature) {
        this._featureType = featureType;
    }

    get Guid(): string {
        return this._guid;
    }

    set Guid(guid: string) {
        this._guid = guid;
    }

    get DeviceGuid(): string {
        return this._deviceGuid;
    }

    set DeviceGuid(value: string) {
        this._deviceGuid = value;
    }

    get Channel(): number {
        return this._channel;
    }

    set Channel(value: number) {
        this._channel = value;
    }
}